<template>
  <div id="inhalt">
    <div class="py-10 chapter-color">
      <v-container>
        <v-row class="justify-center">
          <v-col cols="12" class="text-center">
            <div
              class="text-uppercase display-2 pa-6 hidden-sm-and-down"
              style="color: #2E3440;"
            >
              Ergebnisse Digital-Report
            </div>
            <div
              class="text-uppercase headline pa-6 hidden-md-and-up"
              style="color: #2E3440;"
            >
              Ergebnisse Digital-Report
            </div>

            <v-divider
              style="border-color: #7D9B38; border-width: 5px; width:20%; display: inline-block; border-style: dotted none none none"
              class="mb-4"
            ></v-divider>

            <v-row>
              <v-col cols="12" md="4" class="my-2">
                <v-card flat class="text-center my-6 mx-auto" height="70%">
                  <v-avatar size="164">
                    <v-img src="/images/Icon-Cancen.svg"></v-img>
                  </v-avatar>
                  <v-card-title
                    class="justify-center body-1 font-weight-medium hidden-md-and-down"
                    style="color: #005a85"
                  >
                    Herausforderungen &amp; Chancen
                  </v-card-title>
                  <v-card-title
                    class="justify-center body-2 font-weight-medium hidden-lg-and-up"
                    style="color: #005a85"
                  >
                    Herausforderungen &amp; Chancen
                  </v-card-title>
                  <v-card-text class="justify-center grow">
                    Wie gestalten Non-Profit-Organisationen den digitalen
                    Wandel? Was bereitet ihnen Schwierigkeiten? Bei welchen
                    Technologien sehen sie Potenzial?
                  </v-card-text>
                </v-card>
                <v-card flat class="py-4">
                  <v-card-actions class="pa-6 pt-0 justify-center">
                    <v-btn
                      color="#005a85"
                      dark
                      depressed
                      rounded
                      min-width="90%"
                      @click="$vuetify.goTo('#kapitel1')"
                      >Mehr erfahren</v-btn
                    >
                  </v-card-actions>
                </v-card>
              </v-col>
              <v-col cols="12" md="4" class="my-2">
                <v-card flat class="text-center my-6 mx-auto" height="70%">
                  <v-avatar size="164">
                    <v-img src="/images/Icon-Organisation.svg"></v-img>
                  </v-avatar>
                  <v-card-title
                    class="justify-center body-1 font-weight-medium hidden-md-and-down"
                    style="color: #d62b03"
                  >
                    Digitalisierung der Organisationen
                  </v-card-title>
                  <v-card-title
                    class="justify-center body-2 font-weight-medium hidden-lg-and-up"
                    style="color: #d62b03"
                  >
                    Digitalisierung der Organisationen
                  </v-card-title>
                  <v-card-text class="justify-center grow">
                    Wie digital sind Non-Profits derzeit? Was ist der aktuelle
                    Stand bei technischer Infrastruktur, Organisation,
                    Investitionen und sozialen Medien?
                  </v-card-text>
                </v-card>
                <v-card flat class="py-4">
                  <v-card-actions class=" pa-6 pt-0 justify-center">
                    <v-btn
                      color="#d62b03"
                      dark
                      depressed
                      rounded
                      min-width="90%"
                      @click="$vuetify.goTo('#kapitel2')"
                      >Mehr erfahren</v-btn
                    >
                  </v-card-actions>
                </v-card>
              </v-col>
              <v-col cols="12" md="4" class="my-2">
                <v-card flat class="text-center my-6 " height="70%">
                  <v-avatar size="164">
                    <v-img src="/images/Icon-Reifegrad.svg"></v-img>
                  </v-avatar>
                  <v-card-title
                    class="justify-center body-1 font-weight-medium hidden-md-and-down"
                    style="color: #9d0c4a"
                  >
                    Digitaler Reifegrad
                  </v-card-title>
                  <v-card-title
                    class="justify-center body-2 font-weight-medium hidden-lg-and-up"
                    style="color: #9d0c4a"
                  >
                    Digitaler Reifegrad
                  </v-card-title>
                  <v-card-text class="justify-center ">
                    Welche Faktoren beeinflussen die Digitalisierung einer
                    Organisation? Was sagt uns der digitale Reifegrad einer
                    Organisation?
                  </v-card-text>
                </v-card>
                <v-card flat class="py-4">
                  <v-card-actions
                    class=" pa-6 pt-0 justify-center align-self-end"
                  >
                    <v-btn
                      color="#9d0c4a"
                      dark
                      bottom
                      depressed
                      rounded
                      min-width="90%"
                      @click="$vuetify.goTo('#kapitel3')"
                      >Mehr erfahren</v-btn
                    >
                  </v-card-actions></v-card
                >
              </v-col>
            </v-row>
          </v-col>
        </v-row>
      </v-container>
    </div>
  </div>
</template>

<script>
export default {
  name: "Contenttable"
};
</script>

<style scoped>
.chapter-color {
  background-color: #fff;
  min-height: 20em;
}
.component-color {
  background-color: #fff;
}
</style>
